<div class="error-state-card-container">
  <mat-card appearance="outlined" class="error-state-card">
    <h1 class="title">{{ title }}</h1>
    <p class="body">{{ body }}</p>

    @if (showGoToMaps) {
      <la-button appearance="primary" (action)="goToMaps.emit()">Go to maps</la-button>
    }
  </mat-card>
</div>
